import IServiceCall from "../models/IServiceCall";

export function formatDescription(description: string) {
  let newDescription = description.replace(/(?:\r\n|\r|\n)/g, "<br />");
  return newDescription;
}

export function getArea(sc: IServiceCall) {
  if (sc.product.toLowerCase() === "qmlativ") {
    let area = "";

    if (sc.module) {
      area = sc.module;
    } else {
      return area;
    }

    if (sc.object) {
      area = area + ` - ${sc.object}`;
    } else {
      return area;
    }

    if (sc.screen) {
      area = area + ` - ${sc.screen}`;
    }

    return area;
  } else {
    if (sc.labelPath.length > 58) {
      // remove internal stuff customer doesn't care about
      return sc.labelPath.substr(58);
    }
    return sc.labelPath;
  }
}
